import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";

import Login from "./pages/auth/login/login";
import Dashboard from "./pages/acceuil/acceuil";
import Users from "./pages/users/index";
import CreateUser from "./pages/users/create";
import DashboardHeader from "./pages/template/_header";
import EditUser from "./pages/users/edit";
import Posts from "./pages/posts/index";
import EditPost from "./pages/posts/edit";
import CreatePost from "./pages/posts/create";
import Categories from "./pages/categories/index";
import CreateCategory from "./pages/categories/create";
import EditCategory from "./pages/categories/edit";
import GalleryIndex from "./pages/galery/index";
import Comments from "./pages/comments/index";
import Newsletter from "./pages/NewsLetter/NewsLetter";
import IndexNewsLetter from "./pages/NewsLetter";
import CreateLetter from "./pages/NewsLetter/create";
import SharePost from "./pages/NewsLetter/sharePost";
import ChatIndex from "./pages/chat/index";
import Chat from "./pages/chat/Chat";
import ClosedTickets from "./pages/chat/ClosedTickets";

import { useAuth } from "./AuthContext";
import AdminRoute from "./components/AdminRoute";
import GuestRoute from "./components/GuestRoute";

function AppContent() {
  const { isAuthenticated, isAdmin } = useAuth();
  const location = useLocation();

  const isDashboardRoute = location.pathname.startsWith("/dashboard");
  const showHeader = isAuthenticated && isAdmin && isDashboardRoute;

  return (
    <>
      {showHeader && <DashboardHeader />}

      <Routes>
        {/* Login */}
        <Route
          path="/"
          element={
            <GuestRoute>
              <Login />
            </GuestRoute>
          }
        />

        {/* Dashboard */}
        <Route
          path="/dashboard"
          element={
            <AdminRoute>
              <Dashboard />
            </AdminRoute>
          }
        />

        {/* Users */}
        <Route
          path="/dashboard/users"
          element={
            <AdminRoute>
              <Users />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/users/create"
          element={
            <AdminRoute>
              <CreateUser />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/users/edit/:id"
          element={
            <AdminRoute>
              <EditUser />
            </AdminRoute>
          }
        />

        {/* Comments */}
        <Route
          path="/dashboard/comments"
          element={
            <AdminRoute>
              <Comments />
            </AdminRoute>
          }
        />

        {/* Posts */}
        <Route
          path="/dashboard/posts"
          element={
            <AdminRoute>
              <Posts />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/posts/edit/:id"
          element={
            <AdminRoute>
              <EditPost />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/posts/create"
          element={
            <AdminRoute>
              <CreatePost />
            </AdminRoute>
          }
        />

        {/* Categories */}
        <Route
          path="/dashboard/categories"
          element={
            <AdminRoute>
              <Categories />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/categories/create"
          element={
            <AdminRoute>
              <CreateCategory />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/categories/edit/:id"
          element={
            <AdminRoute>
              <EditCategory />
            </AdminRoute>
          }
        />

        {/* Gallery */}
        <Route
          path="/dashboard/galerie"
          element={
            <AdminRoute>
              <GalleryIndex />
            </AdminRoute>
          }
        />

        {/* NewsLetter */}
        <Route
          path="/dashboard/newsletter"
          element={
            <AdminRoute>
              <Newsletter />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/newsletter/subscribers"
          element={
            <AdminRoute>
              <IndexNewsLetter />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/newsletter/create"
          element={
            <AdminRoute>
              <CreateLetter />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/newsletter/share-post"
          element={
            <AdminRoute>
              <SharePost />
            </AdminRoute>
          }
        />

        {/* Chat */}
        <Route
          path="/dashboard/chat"
          element={
            <AdminRoute>
              <Chat />
            </AdminRoute>
          }
        />

        <Route
          path="/dashboard/chat/open"
          element={
            <AdminRoute>
              <ChatIndex />
            </AdminRoute>
          }
        />

        <Route
          path="/dashboard/chat/history"
          element={
            <AdminRoute>
              <ClosedTickets />
            </AdminRoute>
          }
        />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;
